import { ImgProxy } from '@big-red-group/storefront-common-ui'
import styled from 'styled-components'

export const OffCanvasWrapperBg = styled.div<{ topbarHeight: number }>`
  position: fixed;
  top: ${({ topbarHeight }) => topbarHeight}px;
  left: 0;
  width: 100%;
  height: calc(100% - 80px);
  background: rgba(0, 0, 0, 0.2);
  display: none;
  z-index: 1;
  transition: 0.3s ease-in-out;

  @media (max-width: 768px) {
    height: calc(100% - 68px);
  }
`

export const MenuWrapper = styled.div`
  background: white;
  padding: 32px;
  z-index: 2;
  position: relative;
  left: -30%;
  width: 275px;
  border-top: 1px solid var(--grey-25);
  transition: 0.3s ease-in-out;
  overflow: auto;
  box-sizing: border-box;
`

export const SubmenuWrapper = styled.div<{ thirdMenuToggled: boolean }>`
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 2;
  width: 460px;
  background: white;
  overflow: ${({ thirdMenuToggled }) => (thirdMenuToggled ? 'hidden' : 'auto')};
  box-sizing: border-box;
  border-left: 1px solid var(--grey-25);
  border-top: 1px solid var(--grey-25);
  padding: 32px;
  pointer-events: none;
  display: none;
  transition: 0.3s ease-in-out;

  &.submenu-active {
    pointer-events: all;
    display: block;
    left: 100%;
  }

  @media (max-width: 767px) {
    width: 100vw;
    left: -50%;
    border-left: 0;

    &.submenu-active {
      left: 0;
    }
  }
`

export const ThirdMenuWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 200px;
  z-index: 3;
  width: 460px;
  background: white;
  overflow: auto;
  height: 100%;
  box-sizing: border-box;
  padding: 32px;
  pointer-events: none;
  display: none;
  transition: 0.3s ease-in-out;
  cursor: default;
  border-left: 1px solid var(--grey-25);
  border-top: 1px solid var(--grey-25);

  &.submenu-active {
    pointer-events: all;
    display: block;
    left: 275px;
  }

  @media (max-width: 767px) {
    width: 100%;
    left: -50%;
    border-left: 0;

    &.submenu-active {
      left: 0;
    }
  }
`

export const OffCanvasWrapper = styled.div<{ topbarHeight: number }>`
  pointer-events: none;
  display: none;
  position: fixed;
  top: ${({ topbarHeight }) => topbarHeight}px;
  left: 0;
  z-index: 3;
  transition: 0.3s ease-in-out;

  ${MenuWrapper},
  ${SubmenuWrapper},
  ${ThirdMenuWrapper} {
    height: calc(100vh - ${({ topbarHeight }) => topbarHeight}px);
  }

  ${ThirdMenuWrapper} {
    top: ${({ topbarHeight }) => topbarHeight}px;
  }

  &.menu-active {
    pointer-events: all;
    display: block;

    .menu-wrapper {
      left: 0;
    }
    .menu-bg {
      display: block;
    }
  }
`

export const MenuGroup = styled.div`
  padding: 32px 0;

  &:nth-child(n + 1) {
    border-bottom: 1px solid var(--grey-25);
  }
`

export const MenuGroupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
`

export const MenuGroupHeaderLink = styled.a`
  font-size: 14px;
  font-weight: var(--font-regular);
  color: var(--brand-secondary);
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`

export const MenuGroupLabel = styled.div`
  font-size: 14px;
  color: #868686;
  font-weight: var(--font-regular);
  margin-bottom: 32px;
  text-transform: capitalize;
`

export const LevelOneLink = styled.div<{ isSelected: boolean }>`
  margin: 24px 0;
  cursor: pointer;
  color: var(--brand-secondary);
  display: flex;
  flex-direction: row;
  text-transform: capitalize;

  a {
    text-decoration: none;
    color: inherit;
    width: 100%;

    > div {
      width: 100%;
      justify-content: flex-start;
    }
  }

  svg {
    margin-left: auto;
  }

  &:last-child {
    margin-bottom: 0;
  }

  p {
    position: relative;

    &:before {
      content: '';
      display: block;
      background: red;
      top: calc(100% + 7px);
      left: 0;
      width: 0;
      height: 5px;
      position: absolute;
      background: url('/underline.png') center 100%/100% no-repeat;
      transition: 0.25s var(--cubicBezier);
    }
  }

  &:hover p::before,
  &.link-active p::before {
    width: 62px;
  }
`

export const CloseIcon = styled.span`
  display: block;
  position: absolute;
  top: 19px;
  right: 24px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  transition: 0.3s var(--cubicBezier);

  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 2px;
    border-radius: 1px;
    background: var(--brand-secondary);
  }
  &:before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  &:hover {
    transform: scale(1.1);
  }
`

export const SubmenuGroup = styled.div`
  padding: 32px 0;
`

export const SubmenuGrid = styled.div`
  display: grid;
  align-items: flex-start;

  &.large-thumbnail {
    grid-template-columns: minmax(0, 50%) minmax(0, 50%);
    gap: 24px;
  }

  &.medium-thumbnail {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1px;
    background: #f3f4f6;
  }
`

export const SubmenuGridItem = styled.div`
  font-size: 16px;
  font-weight: var(--font-regular);
  cursor: pointer;

  > .grid-item-wrap {
    text-decoration: none;
    color: var(--brand-secondary);
  }
  &.medium-thumbnail > .grid-item-wrap {
    padding: 12px 0;
    background: white;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: 54px;
    box-sizing: border-box;
  }

  &:hover {
    > .grid-item-wrap > div {
      box-shadow: 0 0 0 3px var(--brand-primary);
    }
  }
`

export const SubmenuGridItemImage = styled(ImgProxy)<{ largeImage: boolean }>`
  height: 40px;
  width: 40px;
  margin: 0 12px 0 0;
  position: relative;
  border-radius: 8px;
  object-fit: cover;

  ${({ largeImage }) =>
    largeImage &&
    `
    height: 135px;
    width: 100%;
    margin: 0 0 12px 0;
    border-radius: 16px;
  `}
`

export const BackLink = styled.div`
  cursor: pointer;
  position: absolute;
  top: 19px;
  left: 24px;
  font-weight: var(--font-medium);

  svg {
    margin-right: 6px;
    position: relative;
    top: 2px;
    left: 0;
    transition: 0.1s var(--cubicBezier);
  }

  &:hover svg {
    left: -3px;
  }
`

export const SubmenuGridItemIcon = styled.div`
  height: 40px;
  width: 40px;
  margin: 0 12px 0 0;
  border-radius: 8px;
  transition: 0.05s ease-in-out;
  border: 1px solid black;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    stroke: var(--text-primary);
  }
`
